/**
 * @author NikolaV
 */
import { isCluster, latLonToEN } from '../ol-utils';
import { FeatureMouseInteraction } from '../interaction/FeatureMouseInteraction';
import Feature, { FeatureLike } from 'ol/Feature';

import { Point as OlPoint } from 'ol/geom';
import * as olStyle from 'ol/style';
import { CanvasUtils } from '@shared/utils/CanvasUtils';


const FEATURE_TYPE = 'image';

function makeBasicIcon(degrees = 0) {
    return `<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 250 250" xml:space="preserve">
<rect x="46.9" y="63" style="fill:#FFFFFF;stroke:#3A3A3A;stroke-width:5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;" width="131" height="107"/>
<rect x="55.8" y="73" style="fill:#D8E8EF;stroke:#BDCCD4;stroke-width:2;stroke-miterlimit:10;" width="112.8" height="87.5"/>
<path style="fill:#65AF46;" d="M109.1,127c-6.2-1.6-24.7-7-24.7-7v41h84.2c0.8-0.6,2.8-49.2-17.8-32S115.3,128.6,109.1,127z"/>
<path style="fill:#33C950;" d="M81.5,101c-14-2-26.2,9-26.2,9v51h97.6c0-1,0.9-10.9-23.6-21.4S95.6,103,81.5,101z"/>
</svg>`
}

function makePanoIcon(degrees = 0) {
    return `<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 250 250" xml:space="preserve">
<path style="fill:#FFFFFF;stroke:#3A3A3A;stroke-width:5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;" d=" \tM193.2,174.3C144.9,140.3,80,140,31.7,172c0-39,0-78.1,0-117C80,87.1,144.9,86.6,193.2,52.7C193.2,93,193.2,133.7,193.2,174.3z"/>
<path style="fill:#DFEDF4;stroke:#BDCCD4;stroke-width:2;stroke-miterlimit:10;" d="M182.6,157.9c-21-11-44.5-16.6-68.2-17.7 \tc-25.2,0.1-50.4,5.3-72.8,16.3c0-28.6,0-57.3,0-85.8C63.4,82,87.8,87.3,112.1,88.2c24.4-1.3,48.7-6.9,70.5-18.9
\tC182.6,98.9,182.6,128.3,182.6,157.9z"/>
<path style="fill:#C96900;" d="M42.8,140.2c0,0,16.7-44.6,31.6-44.6s29.9,26.4,35.6,26.4c5.7,0,14.9-11.5,23-11.5 \tc8,0,35.6,39.1,35.6,39.1s-28.7-10.3-63.2-10.3c-25.3,0-62.1,13.8-62.1,13.8L42.8,140.2z"/>
</svg>`
}

function makeGroupIcon(count = 1) {
    return `<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 800 800" xml:space="preserve"><circle style="fill:white;stroke:#8f8f8f;stroke-width:30;stroke-miterlimit:10;" cx="374.3" cy="376" r="364.7"/>
<rect x="49" y="81.9" style="fill:#FFFFFF;stroke:#3A3A3A;stroke-width:22;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;" width="387.4" height="316.5"/>
<rect x="75.3" y="111.5" style="fill:#D8E8EF;stroke:#BDCCD4;stroke-width:2;stroke-miterlimit:10;" width="333.6" height="258.8"/>
<rect x="157.2" y="178.4" style="fill:#FFFFFF;stroke:#3A3A3A;stroke-width:22;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;" width="431.8" height="352.7"/>
<rect x="186.6" y="211.3" style="fill:#D8E8EF;stroke:#BDCCD4;stroke-width:2;stroke-miterlimit:10;" width="371.8" height="288.4"/>
<rect x="247.1" y="311" style="fill:#FFFFFF;stroke:#3A3A3A;stroke-width:22;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;" width="471.2" height="384.9"/>
<rect x="279.1" y="347" style="fill:#D8E8EF;stroke:#BDCCD4;stroke-width:2;stroke-miterlimit:10;" width="405.8" height="314.7"/>
<path style="fill:#65AF46;" d="M470.9,541.2C448.6,535.5,382,516,382,516v147.5h302.9c2.9-2.2,10.1-177-64-115.1
\tS493.2,547,470.9,541.2z"/>
<path style="fill:#33C950;" d="M371.6,447.7c-50.4-7.2-94.2,32.4-94.2,32.4v183.5h351.1c0-3.6,3.2-39.2-84.9-77
\tC455.4,548.8,422.3,454.9,371.6,447.7z"/><text transform="matrix(1.0132 0 0 1 -18.8017 711.3556)" style="stroke:#fff;stroke-width:19;stroke-miterlimit:10;font-family:'Arial';font-size:380px; font-weight: bold">${count}</text></svg>`;
}

function makePanoGroupIcon(count = 1) {
    return `<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 800 800" xml:space="preserve"><style>
.s0 { fill: #ffffff;stroke: #8f8f8f;stroke-miterlimit:10;stroke-width: 30 }
.s1 { fill: #ffffff;stroke: #3a3a3a;stroke-linecap: round;stroke-linejoin: round;stroke-width: 24 }
.s2 { fill: #dfedf4;stroke: #bdccd4;stroke-miterlimit:10;stroke-width: 2 }
.s3 { fill: #c96900 }
</style><circle style="fill:white;stroke:#8f8f8f;stroke-width:30;stroke-miterlimit:10;" cx="374.3" cy="376" r="364.7"/>
<path class="s0" d="m374.3 740.7c-201.7 0-364.7-163-364.7-364.7 0-201.7 163-364.7 364.7-364.7 201.7 0 364.7 163 364.7 364.7 0 201.7-163 364.7-364.7 364.7z"/>
<path class="s1" d="m564.1 460.9c-155.2-109.3-363.8-110.3-519.1-7.4 0-125.4 0-251.1 0-376.1 155.3 103.2 363.9 101.6 519.1-7.4 0 129.5 0 260.4 0 390.9z"/>
<path class="s2" d="m530.1 408.2c-67.5-35.4-143.1-53.4-219.3-56.9-81 0.3-162 17-234 52.4 0-92 0-184.2 0-275.8 70.1 36.3 148.5 53.3 226.6 56.2 78.5-4.2 156.6-22.2 226.7-60.7 0 95.1 0 189.6 0 284.8z"/>
<path class="s1" d="m659.1 556.9c-155.2-109.3-363.8-110.3-519.1-7.4 0-125.4 0-251.1 0-376.1 155.3 103.2 363.9 101.6 519.1-7.4 0 129.5 0 260.4 0 390.9z"/>
<path class="s2" d="m625.1 504.2c-67.5-35.4-143.1-53.4-219.3-56.9-81 0.3-162 17-234 52.4 0-92 0-184.2 0-275.8 70.1 36.3 148.5 53.3 226.6 56.2 78.5-4.2 156.6-22.2 226.7-60.7 0 95.1 0 189.6 0 284.8z"/>
<path class="s1" d="m659.1 556.9c-155.2-109.3-363.8-110.3-519.1-7.4 0-125.4 0-251.1 0-376.1 155.3 103.2 363.9 101.6 519.1-7.4 0 129.5 0 260.4 0 390.9z"/>
<path class="s2" d="m625.1 504.2c-67.5-35.4-143.1-53.4-219.3-56.9-81 0.3-162 17-234 52.4 0-92 0-184.2 0-275.8 70.1 36.3 148.5 53.3 226.6 56.2 78.5-4.2 156.6-22.2 226.7-60.7 0 95.1 0 189.6 0 284.8z"/>
<path class="s1" d="m757.1 647.9c-155.2-109.3-363.8-110.3-519.1-7.4 0-125.4 0-251.1 0-376.1 155.3 103.2 363.9 101.6 519.1-7.4 0 129.5 0 260.4 0 390.9z"/>
<path class="s2" d="m723.1 595.2c-67.5-35.4-143.1-53.4-219.3-56.9-81 0.3-162 17-234 52.4 0-92 0-184.2 0-275.8 70.1 36.3 148.5 53.3 226.6 56.2 78.5-4.2 156.6-22.2 226.7-60.7 0 95.1 0 189.6 0 284.8z"/>
<path class="s3" d="m273.7 538.3c0 0 53.7-143.4 101.6-143.4 47.9 0 96.1 84.9 114.4 84.9 18.3 0 47.9-37 73.9-37 25.7 0 114.5 125.7 114.5 125.7 0 0-92.3-33.1-203.2-33.1-81.3 0-199.6 44.3-199.6 44.3z"/>
<text transform="matrix(1.0132 0 0 1 -18.8017 711.3556)" style="stroke:#fff;stroke-width:19;stroke-miterlimit:10;font-family:'Arial';font-size:380px; font-weight: bold">${count}</text></svg>`;
}

function makeMixedGroupIcon(count = 1) {
    return `<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 800 800" xml:space="preserve"><style>
.s0 { fill: #ffffff;stroke: #8f8f8f;stroke-miterlimit:10;stroke-width: 30 }
.s1 { fill: #ffffff;stroke: #3a3a3a;stroke-linecap: round;stroke-linejoin: round;stroke-width: 22 }
.s2 { fill: #ffffff;stroke: #3a3a3a;stroke-linecap: round;stroke-linejoin: round;stroke-width: 24 }
.s3 { fill: #dfedf4;stroke: #bdccd4;stroke-miterlimit:10;stroke-width: 2 }
.s4 { fill: #c96900 }
.s5 { fill: #d8e8ef;stroke: #bdccd4;stroke-miterlimit:10;stroke-width: 2 }
.s6 { fill: #65af46 }
.s7 { fill: #33c950 }
</style>
<circle style="fill:white;stroke:#8f8f8f;stroke-width:30;stroke-miterlimit:10;" cx="374.3" cy="376" r="364.7"/>
<path class="s1" d="m188.1 183h471.2v384.9h-471.2z"/>
<path class="s2" d="m592.7 472.4c-165-116.1-386.7-117.2-551.7-7.8 0-133.3 0-266.9 0-399.7 165 109.6 386.7 107.9 551.7-7.9 0 137.6 0 276.7 0 415.4z"/>
<path class="s3" d="m556.5 416.4c-71.7-37.6-152-56.7-233-60.4-86.1 0.3-172.2 18-248.7 55.6 0-97.7 0-195.7 0-293.1 74.5 38.6 157.8 56.7 240.8 59.8 83.4-4.5 166.4-23.6 240.9-64.5 0 101 0 201.4 0 302.6z"/>
<path class="s4" d="m78.9 356c0 0 57.1-152.4 108-152.4 50.9 0 102.1 90.2 121.6 90.2 19.4 0 50.9-39.3 78.5-39.3 27.3 0 121.7 133.5 121.7 133.5 0 0-98.1-35.1-215.9-35.1-86.4 0-212.2 47.1-212.2 47.1z"/>
<path class="s1" d="m247.1 311h471.2v384.9h-471.2z"/>
<path class="s5" d="m279.1 347h405.8v314.7h-405.8z"/>
<path class="s6" d="m470.9 541.2c-22.3-5.7-88.9-25.2-88.9-25.2v147.5h302.9c2.9-2.2 10.1-177-64-115.1-74.1 61.9-127.7-1.4-150-7.2z"/>
<path class="s7" d="m371.6 447.7c-50.4-7.2-94.2 32.4-94.2 32.4v183.5h351.1c0-3.6 3.2-39.2-84.9-77-88.2-37.8-121.3-131.7-172-138.9z"/>
</svg>`;
}

const pngs = {
    basic: null,
    pano: null,
    basicGroup: null,
    panoGroup: null,
    mixedGroup: null
};

// we can't use svg for icons in openlayers, big performance hit in chrome only, so we have to use pngs
const convertIcons = async () => {
    pngs.basic = await CanvasUtils.makeImage(await CanvasUtils.svgToPng(makeBasicIcon(), 2));
    pngs.pano = await CanvasUtils.makeImage(await CanvasUtils.svgToPng(makePanoIcon(), 2));
    pngs.basicGroup = await CanvasUtils.makeImage(await CanvasUtils.svgToPng(makeGroupIcon(0), 2));
    pngs.panoGroup = await CanvasUtils.makeImage(await CanvasUtils.svgToPng(makePanoGroupIcon(0), 2));
    pngs.mixedGroup = await CanvasUtils.makeImage(await CanvasUtils.svgToPng(makeMixedGroupIcon(0), 2));
}
convertIcons();

const groupStyleCache = {}; // cluster icons
const directionLineCache = {}; // normal image icons

const styles = {
    hidden: new olStyle.Style({
        image: new olStyle.Circle({
            fill: new olStyle.Fill({
                color: [0, 0, 0, 0.005],
            }),
            radius: 15,
        }),
    }),
};

function styleFunction(feature: FeatureLike, iconScale = 1, mapRotationDeg = 0) {
    if (isCluster(feature)) { // is a cluster
        const feature0 = feature.get('features')[0];
        const data = feature0.get('data');
        if (data.geographicPoint.lat == 0 && data.geographicPoint.lon == 0) {
            return null;
        }
        const features = feature.get('features') as Feature[];
        const count = features.length;
        const panoCount = features.filter(f => (f.get('data') as IImage).panorama).length;
        return [renderGroupStyle(count, iconScale, panoCount)];
    }
    else {
        feature = feature.get('features')[0]; // single feature is also a cluster just with one feature in it
        const data = feature.get('data');
        if (data.geographicPoint.lat == 0 && data.geographicPoint.lon == 0) {
            return null;
        }
        const degrees = data ? data.direction : 0;
        return [renderDirectionLine(degrees, data && data.panorama, iconScale, mapRotationDeg)];
    }
}

// renders group icon + count
function renderGroupStyle(count: number = 0, iconScale = 1, panoCount = 0) {
    const cacheKey = count + String(iconScale) + panoCount;
    if (groupStyleCache[cacheKey]) return groupStyleCache[cacheKey];

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const groupImg = (panoCount > 0 ? (count === panoCount ? pngs.panoGroup : pngs.mixedGroup) : pngs.basicGroup);
    canvas.width = groupImg.width;
    canvas.height = groupImg.height;
    ctx.drawImage(groupImg, 0, 0);
    ctx.font = '30px Arial';
    ctx.lineWidth = 3;
    ctx.strokeStyle = '#FFFFFF';
    ctx.fillStyle = '#000000';
    const text = count.toString();
    const x = 0;
    const y = groupImg.height - 5;
    ctx.strokeText(text, x, y);
    ctx.fillText(text, x, y);

    const style = new olStyle.Style({
        image: new olStyle.Icon({
            src: canvas.toDataURL('image/png'),
            anchor: [0.45, 0.45],
            scale: iconScale * 0.5
        })
    });

    groupStyleCache[cacheKey] = style;
    return style;
}

// renders image icon + direction line
function renderDirectionLine(degrees: any = 0, panorama = false, iconScale = 1, mapRotationDeg = 0) {
    degrees = parseInt(degrees) + mapRotationDeg;
    const cacheKey = degrees + '_' + (panorama ? 'true' : 'false') + '_' + iconScale;
    if (directionLineCache[cacheKey]) return directionLineCache[cacheKey];

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const iconImg = panorama ? pngs.pano : pngs.basic;
    canvas.width = iconImg.width + 5;
    canvas.height = iconImg.height + 5;
    ctx.fillStyle = '#FFFFFF';
    //ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.translate(canvas.width / 2, canvas.height / 2);
    ctx.save();
    ctx.rotate(degrees * Math.PI / 180);
    ctx.beginPath();
    ctx.lineWidth = 3;
    ctx.moveTo(0, 0);
    ctx.lineTo(0, -canvas.height / 2 + 5);
    ctx.stroke();
    ctx.closePath();
    ctx.restore();
    ctx.drawImage(iconImg, -iconImg.width / 2 + 3, -iconImg.height / 2 + 3);


    const style = new olStyle.Style({
        image: new olStyle.Icon({
            src: canvas.toDataURL('image/png'),
            scale: iconScale * 0.5,
            anchor: [0.45, 0.45]
        }),
    });


    directionLineCache[cacheKey] = style;
    return style;
}

function makeFeature(image: IImage, mouseInteraction?: FeatureMouseInteraction): Feature {
    if (!image) {
        console.error('ImagesFeatureFactory.makeFeature() - image data undefined', image);
        return null;
    }

    if (!image.geographicPoint) {
        return null;
    }

    const coord: Coordinate = latLonToEN(image.geographicPoint.lat, image.geographicPoint.lon);
    if (!coord) {
        //console.warn('ImagesFeatureFactory.makeFeature() - bad coordinates', image);
        return null;
    }

    const feature = new Feature({
        geometry: new OlPoint(coord),
    });

    feature.setId(image.id);
    feature.set('type', FEATURE_TYPE);
    feature.set('data', image);
    feature.set('no_hover_style', true);
    feature.set('mouseInteraction', mouseInteraction);

    return feature;
}

export const ImageFeatureFactory = {
    makeFeature,
    styleFunction,
    FEATURE_TYPE,
};
